import {v4 as uuidv4} from 'uuid'
import pic1 from "../Images/1045961082178622568.jpg";
import pic2 from "../Images/1075023373524976088.jpg";

export const Images = () => {
    return[
        {
            title: "Pinterest Drawing 1",
            source: "pinterest",
            url: [
                "https://www.pinterest.co.uk/pin/774124927095260/"
            ],
            description: "Saw the kirby hat, thought it was cute. Also, wanted to practice hands.",
            img: pic1,
            num: "01",
            id: uuidv4(),
        },
        {
            title: "Pinterest Drawing 2",
            source: "pinterest",
            url: [
                "https://www.pinterest.co.uk/pin/1107041152124875366/"
            ],
            description: "The outfit looked adorable and funny. The toy... not so much.",
            img: pic2,
            num: "02",
            id: uuidv4(),
        },
        // {
        //     title: "",
        //     source: "",
        //     url: [""],
        //     domain: "",
        //     description: "",
        // },
    ]
};